import createApiClient from "./apiClient";

export const get = async <T = any>(path = "/salesAgent-settingsApi", data?: object): Promise<T> => {
  try {
    const apiClient = await createApiClient();
    const response = await apiClient.get<T>(path, { params: data });
    return response.data;
  } catch (error: any) {
    console.error("Error posting data:", error);
    throw error;
  }
};

export const post = async <T = any>(
  payload: object | FormData,
  path = "/salesAgent-settingsApi"
): Promise<T> => {
  try {
    const apiClient = await createApiClient();
    const config =
      payload instanceof FormData
        ? { headers: { "Content-Type": undefined } as Record<string, undefined> }
        : undefined;
    const response = await apiClient.post<T>(path, payload, config);
    return response.data;
  } catch (error: any) {
    console.error("Error posting data:", error);
    throw error;
  }
};

export const put = async <T = any>(
  payload: object,
  path = "/salesAgent-settingsApi"
): Promise<T> => {
  try {
    const apiClient = await createApiClient();
    const response = await apiClient.put<T>(path, payload);
    return response.data;
  } catch (error: any) {
    console.error("Error posting data:", error);
    throw error;
  }
};

export const deleteData = async <T = any>(
  payload: object,
  path = "/salesAgent-settingsApi"
): Promise<T> => {
  try {
    const apiClient = await createApiClient();
    console.log(payload);
    const response = await apiClient.delete<T>(path, { data: payload });
    return response.data;
  } catch (error: any) {
    console.error("Error posting data:", error);
    throw error;
  }
};
